import gql from 'graphql-tag';

export const addSms = gql`
    mutation addSms($input: [SmsInput!]!){
      response: addSms(inputSms: $input){
        id
      }
    }
`;
